// extracted by mini-css-extract-plugin
export var divider = "_ro-0";
export var systemMessage = "_ro-1";
export var systemMessageWrapper = "_ro-2";